<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <button class="returnBtn" @click="back">返回</button>
     <div class="mt-1 container font">
     <p v-show="error">{{ error }}</p>   
   
         <div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="topTitle">导师列表</div>
        </div>
        <div class="d-flex justify-content">

          <div :class="correct==null?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" 
                @click="correctWrong(null)">全部</div>

             <div :class="correct==false?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" 
                @click="correctWrong(false)">未修正</div>

              <div :class="correct==true?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" 
                @click="correctWrong(true)">已修正</div>

        </div>


        <div class="d-flex justify-content-center">
          <div v-if="tutors.length==0" class="m-1">暂无笔记</div>

          

          <div class="d-flex flex-column justify-content-center"  v-if="tutors.length>0">
          <div v-for="(tutor, index) in tutors" :key="index" class="m-1">
           
            <div class="d-flex justify-content">
              <div>
                <div class="d-flex justify-content">
                    <img :src="tutor.data.tutor_img" class="img" v-if="tutor.data!=undefined&& tutor.data.tutor_img!=undefined && tutor.data.tutor_img!=''">
                    <div v-else>
                      无导师图片
                    </div>
                    
                    <div class="d-flex justify-content">
                     
                        <div v-for="(screen,sindex) in tutor.screens" :key="sindex">
                            <div class="d-flex flex-column">
                              <img :src="screen" style="width:3.5rem;">
                              <div class="backBtn mr-1"  @click="deleteSucai(tutor.objectId,sindex)">删除素材</div>
                            </div>
                              
                          </div>
                    </div>
                   
                </div>
                   
                    
                    <br>
                    <div class="m-1">
                    <div>{{ tutor.data.university_name }}{{ tutor.data.tutor_name }}</div>               
                   
                        <div>
                            <div class="backBtn mr-1" v-if="tutor.beaty==false || tutor.beauty==undefined" @click="beauty(index)">美</div>
                            <div class="backBtn mr-1" v-else @click="beauty(index)">不美</div>

                            <div class="backBtn mr-1" v-if="tutor.wrong_img==undefined ||tutor.wrong_img==false " @click="wrongImg(index)">照片错误</div>


                             <div class="backBtn mr-1" v-if="tutor.wrong_img==true ||tutor.fix_img==true " @click="correctImg(index)">照片正确</div>
                        </div>
                       
                       
                        
                    </div>
                  </div>
               </div>


               <div>
               
               </div>  
               <!-- </div>
               </div>
            </div> -->
            
                    
              </div>
        </div>
        </div>


        <div class="mt-1 pb-1 d-flex justify-content" style="flex-wrap: wrap; max-width: 100%;" v-if="totalPage>0&&isLoading==false">
          <div v-for="(n,index) in totalPage" :key="index">
            <div :class="n==page?'pageBox mr-1 selectedPageBox':'pageBox mr-1 normalPage'" @click="changePage(n)">
              {{ n }}
            </div>
            
          </div>

        </div>
            
    
         </div>
   
      
     </div>

     
   </template>
   
   <script>
   
   import GridLoader from 'vue-spinner/src/GridLoader.vue'
   import axios from 'axios';
   import moment from 'moment';
 
   
   export default {
     data(){
       return {
         isLoading:false,
         keyword:'',
         error:'',
         accountId:'',
         account:null,
         tutors:[],
         spinnerColor:"#262626",
         text:'test\ntest',
         page:1,
         count:2,
         totalPage:1,
        correct:false,
      
         userId:null

       }
       
     },
     computed: {
     localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     },
     
     formatDate(){
      return (datetimeString) => {
        console.log(datetimeString)
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     }
   },
   
     components: {
      GridLoader,

     },
      setup(){
        var token=localStorage.getItem('sessionToken')
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
     },
   
   
     mounted(){
      

      var token=localStorage.getItem('sessionToken')
       
          if(token==undefined || token==null ||token=='')
        {
          this.$router.push('/')
          return
        }
        var role=localStorage.getItem('role')
        if(role==undefined || role==0)
        {
          this.$router.push('/')
          return
        }
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
    
   
       this.getPages()
       this.getTutors()
     },
     methods:{



   





      async beauty(index){
          this.isLoading=true;
            try{
              var tutor=this.tutors[index]
              const response = await axios.get(this.domain+'xhs/beauty_person?series_id='+tutor.objectId);

              var data=response.data
              if(data.status=='Suc')
              {
                if (tutor.beauty==undefined)
              {
                this.tutors[index]['beauty']=true;
              }
              else
              {
                this.tutors[index]['beauty']=!tutor.beauty;
              }
               
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },

      back(){
        this.$router.go(-1)
      },

      
       async getPages(){
         try{
           
            console.log(this.userId)
           const response = await axios.get(this.domain+'xhs/get_tutors_count?correct='+this.correct);
          
           var data=response.data
           if(data['status']=='Suc')
           {

               var count=data['count']
               this.totalPage=Math.ceil(count/this.count)
               this.page=1
              
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
         
       },

       async wrongImg(index){
          this.isLoading=true;
            try{
              var tutor=this.tutors[index]
              const response = await axios.get(this.domain+'xhs/tutor_wrong_img?tutor_id='+tutor.objectId);

              var data=response.data
              if(data.status=='Suc')
              {
                console.log(data)
                // this.notes[index]['wrong_img']=true;
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },


       async correctImg(index){
          this.isLoading=true;
            try{
              var tutor=this.tutors[index]
              const response = await axios.get(this.domain+'xhs/tutor_correct_img?tutor_id='+tutor.objectId);

              var data=response.data
              if(data.status=='Suc')
              {
                this.notes[index]['wrong_img']=true;
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },


       changePage(n){
        if(n==this.page)
        {
          return
        }
        this.page=n
        this.getTutors()
       },
        async getTutors(){
         try{
            this.isLoading=true
           const response = await axios.get(this.domain+'xhs/get_tutors?page='+this.page+'&count='+this.count+'&correct='+this.correct);
          
           var data=response.data
           if(data['status']=='Suc')
           {  
            console.log(data)
               this.tutors=data['tutors']
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
         finally{
          this.isLoading=false
         }
       },


       async deleteSucai(tutor_id, zsk_id){
          this.isLoading=true;
            try{
             
              const response = await axios.get(this.domain+'xhs/delete_tutor_sucai?tutor_id='+tutor_id+'&sucai_id='+zsk_id);

              var data=response.data
              if(data.status=='Suc')
              {
                // this.notes[index]['hide']=0;
                console.log(data)
              }
              else
              {
                  console.error(data)
                  
              }
          }
          catch(error)
          {
              console.error(data)
          }
          finally{
            this.isLoading=false
          }

      },

      correctWrong(correct){

          if(this.correct==correct)
          {
            return
          }
        else
        { 
           if (correct==null || correct==undefined)
           {
            this.correct=undefined
           }
           else{
              this.correct=!this.correct
           }
            
            
            this.getPages()
             this.getTutors()

        }
           
          },


     }
      
     
   };
   </script>
<style scoped>

.img{
    width:3.5rem;
    border-radius: 0.125rem, 0.125rem,0 0;
}

.card{
  height:max-content;
  min-width: 3rem;
  max-width: 4rem;
}

.cardText{
  color: #262626;
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
 text-align: left;
}
.icon{
  width:0.175rem;
  height:0.175rem;
}

.account_icon{
  width:0.5rem;
  height:0.5rem;
  border-radius: 50%;
}


</style>
   